// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"94":"30ca8764","116":"9457fe2a"}[chunkId] + ".chunk.css";
};